import React from 'react';

const PlusIcon = () => {
  return (
    <svg className="plus-icon" width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Plus Icon</title>
      <g id="Report-Downloading-with-Scheduler" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Schedule-Report---Table---Already-Scheduled" transform="translate(-1169.000000, -655.000000)" fill="currentColor">
          <g id="Schedule-List" transform="translate(899.000000, 643.000000)">
            <path className="plus-icon" d="M279,19 L287,19 L287,20 L279,20 L279,28 L278,28 L278,20 L270,20 L270,19 L278,19 L278,12 L279,12 L279,19 Z" id="Add-Thin" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PlusIcon;
